import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import BasicPagination from "../../../../../Pagination/Pagination";
import EditDiner from "../EditDiner";
import ViewDiner from "../ViewDiner";
import AllSeatingUserModal from "./AllSeatingUserModal";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  sa_whole_vd_pending_diner,
  sa_whole_vd_reservation_diner,
} from "../../../../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminSeatingAction";
import { useHistory } from "react-router-dom";
import isEmpty from "../../../../../../store/validation/is-Empty";

const AllSeatingPageComponent = (props) => {
  //state
  // const [];
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const handleCloseView = () => setShowView(false);
  const [modalData, setModalData] = useState([]);
  const handleShowView = (user) => {
    setModalData(user);
    setShowView(true);
  };
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (user) => {
    setModalData(user);
    setShowEdit(true);
  };
  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth?.user?.accessToken : "";
  });
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    let calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const dispatch = useDispatch();
  const history = useHistory();

  const onClickVendorId = (data) => {
    dispatch(
      sa_whole_vd_pending_diner(
        token,
        data.vendor_id,
        data.restaurant_id.subscription,
        (vendorId, subscriptionId) => onSuccess(vendorId, subscriptionId)
      )
    );
    dispatch(
      sa_whole_vd_reservation_diner(
        token,
        data.vendor_id,
        data.restaurant_id.subscription,
        (vendorId, subscriptionId) => onSuccess(vendorId, subscriptionId)
      )
    );
  };

  const onSuccess = (vendorId, subscriptionId) => {
    localStorage.setItem("vendorId", JSON.stringify(vendorId));
    localStorage.setItem("subscriptionId", JSON.stringify(subscriptionId));
    history.push({
      pathname: `/superadmin/vendorseating`,
      state: {
        vendorID: vendorId,
        subscriptionId: subscriptionId,
        // pageBackUrl: `/superadminseatingall`,
        pageAction: "SEATING",
      },
    });
  };

  let filteredData = props.diners;

  return (
    <>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <td style={{ width: "16.66%" }} className="f12-700">
              Restaurant<br /> Name
              </td>
              <td style={{ width: "16.66%" }} className="f12-700">
                Request type/no.
              </td>
              <td style={{ width: "16.66%" }} className="f12-700">
                Total PAX
              </td>
              <td style={{ width: "16.66%" }} className="f12-700">
                Status
              </td>
              <td style={{ width: "16.66%" }} className="f12-700">
                Date/Time
              </td>
              <td style={{ width: "16.66%" }} className="f12-700">
                Actions
              </td>
            </tr>
          </thead>
          {filteredData.slice(start, end).map((seating, index) => (
            <AllSeatingUserModal
              seating={seating}
              key={index}
              handleShowView={(currentUserData) =>
                handleShowView(currentUserData)
              }
              onClickVendorId={onClickVendorId}
              searchSelectedRequestType={props.searchSelectedRequestType}
            />
          ))}
        </Table>
      </div>
      {filteredData.length !== 0 ? (
        <BasicPagination
          totalRecords={filteredData.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}

      <ViewDiner
        onClickCloseView={handleCloseView}
        onClickshowView={showView}
        onClickshowEdit={() => handleShowEdit(modalData)}
        userData={modalData}
      />
    
      {/* <EditDiner
        onClickCloseEdit={handleCloseEdit}
        onClickshowEdit={() => onClickVendorId(modalData)}
        userData={modalData}
        getData={props.getData}
      />  */}
    </>
  );
};

export default AllSeatingPageComponent;
